import { FC, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { SiteModel } from '../../../core/_models'
type Props = {
    site: SiteModel
}
const SiteLotInfoCell: FC<Props> = ({ site }) => (

    <div className='d-flex align-items-center'>
        {site.district}
    </div>

)
export { SiteLotInfoCell }
